import { useEffect, useRef, useState } from "react";
import { CLOUDINARY_INTEL_BASE_URL } from "../../../utils/enum";
import CompanyCardView from "./companyCardView";
import CompanyResultHeaders from "./companyResultHeaders";
import CompanySearchFilters from "./companySearchFilters";
import { sortOptionsCompany } from "../enum";

const SortDropdown = ({ sortField, onSortChange, onSortTrack }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="tw-relative tw-inline-block">
      <div onClick={() => setOpen(!open)} className="tw-cursor-pointer tw-text-sm tw-font-medium tw-text-primary-purple-600 tw-flex tw-items-center tw-justify-between">
        <span className="material-symbols-outlined">swap_vert</span> Sort By: {sortField.label}
      </div>
      {open && (
        <div className="tw-text-sm tw-absolute tw-mt-1 tw-w-full tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-lg tw-z-50">
          {sortOptionsCompany.map((opt) => (
            <div
              key={opt.value}
              onClick={() => {
                onSortChange(opt);
                onSortTrack?.();
                setOpen(false);
              }}
              className={`tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-100 ${sortField.value === opt.value ? "tw-bg-gray-200 tw-font-medium" : ""}`}>
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const CompanyResultsPanel = ({ tableData, rawTableData, totalDataCount, sortField, setSortField, showSort = true, selectedRows, setSelectedRows, selectedRowData, setSelectedRowData, clearSelections, filters, setFilters, initialFilters, hasActiveFilters, countryFilterOptions, currentUserPlan, searchedState, activeTab, getSlugHandler, source = "company_tab", searchSlot = null, onDownloadOverride = null, onSortTrack, onTrackViewContacts, onTrackBookmark }) => (
  <div className="tw-border-t tw-border-gray-200 tw-bg-gray-50 tw-px-5 tw-min-h-[calc(100vh-180px)] tw-pb-6">
    <div className="tw-flex tw-justify-between tw-items-center tw-pt-4 tw-gap-4">
      {searchSlot}
      {showSort && tableData.length > 0 && (
        <div className="tw-flex-shrink-0 tw-ml-auto">
          <SortDropdown sortField={sortField} onSortChange={(sort) => setSortField(sort)} onSortTrack={onSortTrack} />
        </div>
      )}
    </div>

    <div className="tw-flex tw-items-center tw-justify-between tw-text-sm tw-mt-3 tw-gap-4">
      {tableData.length > 0 ? <CompanyResultHeaders selectedRows={selectedRows} setSelectedRows={setSelectedRows} totalDataCount={totalDataCount} clearSelections={clearSelections} singleRow={selectedRowData} setSingleRow={(val) => setSelectedRowData(val)} filters={filters} searchedState={searchedState} sortField={sortField} tableData={tableData} activeTab={activeTab} source={source} onDownloadOverride={onDownloadOverride} /> : <div />}
      <CompanySearchFilters activeTab={activeTab} filters={filters} setFilters={setFilters} tableData={rawTableData} initialFilters={initialFilters} currentUserPlan={currentUserPlan} countryFilterOptions={countryFilterOptions} hasActiveFilters={hasActiveFilters} />
    </div>

    {tableData.length > 0 ? (
      <CompanyCardView tableData={tableData} getSlugHandler={getSlugHandler} setSelectedRowData={setSelectedRowData} setSelectedRows={setSelectedRows} selectedRows={selectedRows} onTrackViewContacts={onTrackViewContacts} onTrackBookmark={onTrackBookmark} />
    ) : (
      <div className="tw-text-[15px] tw-gap-3 tw-border tw-border-gray-200 tw-rounded-lg tw-mx-auto tw-mt-4 tw-h-[calc(100vh-305px)] tw-leading-[1.43] tw-flex tw-justify-center tw-flex-col tw-bg-white">
        <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1759739973/intel/misc/empty_state_nuhcpl.svg`} alt="no-results" className="tw-mx-auto" />
        <div className="tw-text-center tw-mt-4 tw-font-medium">No results found for the applied filters.</div>
      </div>
    )}
  </div>
);

export default CompanyResultsPanel;
